<div class="container">
    <div class="card">
        <div class="card-body">
            <div class="panel panel-primary">
                <div class="panel-heading custom-panel">
                    <div class="titulo-painel-left">
                        <h2>{{tituloCrud}}</h2>
                    </div>
                </div>
            </div>

            <div>
                <form [formGroup]="formularioMedico" (ngSubmit)="onSubmit()" (keydown.enter)="$event.preventDefault()">
                    <div class="form-group">
                        <mat-divider fxFlex="1 0"></mat-divider>
                    </div>

                    <div class="form-row">
                        <mat-form-field class="form-group col-lg-8 col-md-8 col-sm-8 col-12">
                            <mat-label>Nome</mat-label>
                            <input matInput value="Nome" class="form-control" id="nome" required trim="blur" name="nome"
                                formControlName="nome" maxlength="60" upperCase>
                            <mat-error *ngIf="formularioMedico.controls.nome.hasError('required')">
                                O campo Nome é obrigatório.
                            </mat-error>
                            <mat-error *ngIf="formularioMedico.controls.nome.hasError('minlength')">
                                O campo Nome precisa conter mais do que 5 caracteres.
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="form-group col-lg-4 col-md-4 col-sm-4 col-12">
                            <mat-label>CPF</mat-label>
                            <input matInput value="CPF" class="form-control" id="cpf" trim="blur" name="cpf"
                                formControlName="cpf" maxlength="14" trim="blur" nccCpfCnpjMask>
                            <mat-error *ngIf="formularioMedico.controls.cpf.errors">
                                O campo CPF está inválido.
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="form-row">
                        <mat-form-field class="form-group col-lg-8 col-md-8 col-sm-8 col-12">
                            <mat-label>Logradouro</mat-label>
                            <input matInput value="Logradouro" class="form-control" id="logradouro" trim="blur"
                                name="logradouro" formControlName="logradouro" maxlength="60" upperCase>
                            <mat-error *ngIf="formularioMedico.controls.logradouro.hasError('minlength')">
                                O campo Logradouro precisa conter mais do que 5 caracteres.
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="form-group col-lg-4 col-md-4 col-sm-4 col-12">
                            <mat-label>Número</mat-label>
                            <input matInput value="Número" class="form-control" id="numero" name="numero"
                                formControlName="numero" maxlength="10" trim="blur" upperCase>
                        </mat-form-field>
                    </div>

                    <div class="form-row">
                        <mat-form-field class="form-group col-lg-6 col-md-6 col-sm-6 col-12">
                            <mat-label>Bairro</mat-label>
                            <input matInput value="Bairro" class="form-control" id="bairro" trim="blur" name="bairro"
                                formControlName="bairro" maxlength="40" upperCase>
                            <mat-error *ngIf="formularioMedico.controls.bairro.hasError('minlength')">
                                O campo Bairro precisa conter mais do que 5 caracteres.
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="form-group col-lg-6 col-md-6 col-sm-6 col-12">
                            <mat-label>Cidade</mat-label>
                            <input matInput value="Cidade" class="form-control" id="cidade" name="cidade"
                                formControlName="cidade" maxlength="40" trim="blur" upperCase>
                            <mat-error *ngIf="formularioMedico.controls.cidade.hasError('minlength')">
                                O campo Cidade precisa conter mais do que 5 caracteres.
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="form-row">
                        <mat-form-field class="form-group col-lg-5 col-md-7 col-sm-7 col-12">
                            <mat-label>Complemento</mat-label>
                            <input matInput value="Complemento" class="form-control" id="complemento" trim="blur"
                                name="complemento" formControlName="complemento" maxlength="60" upperCase>
                        </mat-form-field>

                        <mat-form-field class="form-group col-lg-3 col-md-5 col-sm-5 col-12">
                            <mat-label>UF</mat-label>
                            <mat-select value="UF" formControlName="estado" name="uf" id="uf">
                                <mat-option *ngFor="let uf of listaUFs" [value]="uf.sigla">
                                    {{uf.nome}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field class="form-group col-lg-2 col-md-6 col-sm-6 col-6">
                            <mat-label>CEP</mat-label>
                            <input matInput value="CEP" class="form-control" id="cep" name="cep" formControlName="cep"
                                maxlength="9" trim="blur" mask="00000-000">
                            <mat-error *ngIf="formularioMedico.controls.cep.errors">
                                O campo CEP está inválido.
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="form-group col-lg-2 col-md-6 col-sm-6 col-6">
                            <mat-label>Fone</mat-label>
                            <input type="text" matInput value="Fone" class="form-control" id="fone" name="fone"
                                phoneMask [maskInputId]="'fone'" [preValue]="formularioMedico.value.fone"
                                [phoneControl]="formularioMedico.controls['fone']" formControlName="fone" minlength="14"
                                maxlength="16">
                            <mat-error *ngIf="formularioMedico.controls.fone.errors">
                                O campo Fone está inválido.
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="form-row">
                        <mat-form-field class="form-group col-lg-9 col-md-9 col-sm-8 col-8">
                            <mat-label>Especialidade</mat-label>
                            <mat-select value="Especialidade" formControlName="especialidade" name="especialidade"
                                id="especialidade" required>
                                <mat-option *ngFor="let especialidade of listaEspecialidades" [value]="especialidade">
                                    {{especialidade.nome}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="formularioMedico.controls.especialidade.hasError('required')">
                                O campo Especialidade é obrigatório.
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field class="form-group col-lg-3 col-md-3 col-sm-4 col-4">
                            <mat-label>Qtd. Dias Agenda</mat-label>
                            <mat-select value="Qtd. Dias Agenda" formControlName="qtdDiasAgenda" name="qtdDiasAgenda"
                                id="qtdDiasAgenda" required>
                                <mat-option *ngFor="let qtdDiasAgenda of listaDiasAgenda" [value]="qtdDiasAgenda.codigo">
                                    {{qtdDiasAgenda.descricao}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="formularioMedico.controls.qtdDiasAgenda.hasError('required')">
                                O campo Qtd. Dias Agenda é obrigatório.
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="menu-formulario">
                        <div class="menu-formulario-botoes margin-right-10" *ngIf="!isInfo">
                            <button mat-mini-fab color="success" type="submit" matTooltip="Salvar"
                                [disabled]="!formularioMedico.valid">
                                <mat-icon>save</mat-icon>
                            </button>
                        </div>
                        <div class="menu-formulario-botoes">
                            <botao-voltar></botao-voltar>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>